import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=72b9e6c2&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=72b9e6c2&prod&scoped=true&lang=css"
import style1 from "@/assets/styles/basic/form.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "@/assets/styles/basic/side-nav.less?vue&type=style&index=2&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9e6c2",
  null
  
)

export default component.exports